import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';
import { Icon, IconTypes } from '../Icon';

interface InputIconWrapperProps {
  children: ReactNode;
  className?: string;
  icon: IconTypes;
  iconFill?: string;
  iconPosition?: 'left' | 'right';
  width?: number;
  onIconClick?: () => void;
  type?: 'button' | 'submit';
}

const WIDTH_ICON_CONTAINER = 30;

const Layout = styled.div<Partial<InputIconWrapperProps>>`
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: ${({ width }) => (width ? toRem(width) : '100%')};
  height: auto;

  input {
    ${({ iconPosition }) =>
      iconPosition === 'left' &&
      css`
        padding-left: ${toRem(WIDTH_ICON_CONTAINER)};
      `}

    ${({ iconPosition }) =>
      iconPosition === 'right' &&
      css`
        padding-right: ${toRem(WIDTH_ICON_CONTAINER)};
      `}
  }
`;

interface IconContainerProps {
  clickable?: boolean;
  iconPosition?: 'left' | 'right';
}

const IconContainer = styled.div<IconContainerProps>`
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${toRem(WIDTH_ICON_CONTAINER)};
  height: 100%;

  ${({ iconPosition }) =>
    iconPosition === 'left' &&
    css`
      left: 0;
    `}

  ${({ iconPosition }) =>
    iconPosition === 'right' &&
    css`
      right: 0;
    `}

  svg {
    width: ${toRem(13.75)};
    height: ${toRem(13.75)};
    fill: ${theme.color.neutral[400]};
    transition: fill ${theme.transition.icon};
  }

  ${({ clickable }) =>
    clickable &&
    css`
      &:hover,
      &:focus {
        svg {
          fill: ${theme.color.neutral[800]};
        }
      }
    `}
`;

const InputIconWrapper = ({ children, className, icon, iconFill, iconPosition = 'left', width, onIconClick, type }: InputIconWrapperProps) => (
  <Layout className={className} width={width} iconPosition={iconPosition}>
    <IconContainer aria-label={onIconClick && 'Click to submit'} as={onIconClick && 'button'} clickable={!!onIconClick} iconPosition={iconPosition} onClick={onIconClick} type={type}>
      <Icon icon={icon} fill={iconFill} />
    </IconContainer>

    {children}
  </Layout>
);

export default InputIconWrapper;
